<template>
  
  <MyProxy />
</template>

<script setup>
import MyProxy from "@/components/Customer/MyProxy/MyProxy.vue";
import { useRoute, useRouter } from 'vue-router';
import {useAlertStore} from '@/stores';
const alertStore = useAlertStore();
const route = useRoute();
const router = useRouter();
const status = route.query?.status || '0';
if (status === '1') {
  alertStore.success("You have purchased successfully")
  // drop ?status=1 from the address so a reload does not repeat the message
  router.replace({ path: route.path })
}
</script>